<template>
<div>
  <div
    class="rich-select sug-select"
    @click="showPopup"
  >
    <span class="content" v-if="content">{{content}}</span>
    <span class="rich-select-placeholder" v-else>{{placeholder}}</span>
    <span v-if="this.sugName !=='UserSugSelect'">
      <i class="rich-select-icon" v-if="!disabled"></i>
    </span>
    <i class="richic-close close-btn" @click="cancleHandle" v-if="this.sugName==='UserSugSelect'"></i>
  </div>
</div>
</template>

<script>
/**
 * sug 选择组件
 * 负责唤起 sug弹窗 和显示结果
 * props: {
 *  type: visitFellowName / padTransactor, （item prop）
 *  sugName: SugSelUser / SugSelImei, (只支持 createAPI 形式的组件, 组件的name)
 * }
 */
import { i18n } from '@/common/utils/i18n'

export default {
  name: 'BankSelect',
  inject: ['rootForm'],
  data () {
    return {
      content: this.value || '',
      username: '',
      phone: ''
    }
  },
  props: {
    value: {
      required: true,
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'visitFellowName' // padTransactor
    },
    placeholder: {
      required: true,
      type: String,
      default: i18n.gettext('请输入')
    },
    sugName: {
      required: false,
      type: String,
      default: 'SugSelUser'
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  async mounted () {
  },
  methods: {
    cancleHandle (event) {
      event.stopPropagation()
      this.content = ''
      this.rootForm.internalData.sellerName = ''
      this.rootForm.internalData.sellerPhone = ''
    },
    showPopup () {
      if (this.disabled) return
      if (this.sugName === 'UserSugSelect') {
        let $select = this[`$create${this.sugName}`]().show()
        $select.$on('select', (value) => {
          // 选择销售姓名后
          let rootData = this.rootForm.internalData
          if (value.userName) {
            if (!rootData.sellerName.includes(value.userName)) {
              let tempUserName = rootData.sellerName ? ',' + value.userName : value.userName
              this.content = rootData.sellerName + tempUserName
              this.rootForm.internalData.sellerName = rootData.sellerName + tempUserName
            }
          }
          $select.hide()
        })
      } else {
        // sugSelUser
        let $select = this[`$create${this.sugName}`]().show()
        $select.$on('select', (value) => {
          this.content = value
          this.$emit('input', value, { prop: this.type })
          this.rootForm.$emit('input', this.rootForm.internalData, { prop: this.type })
          $select.hide()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sug-select {
  text-align: left;
  overflow: auto;

  &-btn {
    text-align: left;
    color: $color-light-grey;
    font-size: $fontsize-medium;
  }

  // 组件使用rich-select需设置disabled属性点击时禁止picker弹出，但不需要disabled的样式
  ::v-deep .rich-select_disabled {
    background-color: #fff
  }

  .panel-wrap {
    width: 100%;
    position: absolute;
    top: 60Px;
    bottom: 0;
    overflow: auto;
    .checkbox {
      padding: 0 20px;
    }
  }

  .content{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 90%;
  }
  .close-btn{
    float: right
  }
}
</style>
